<template>
  <div>
    <section :class="locale" class="d-flex fixed-bottom m-bottom-menu">
      <nav class="m-bottom-menu-list">
        <button
          href="#"
          class="m-bottom-menu-list-item"
          data-bs-toggle="modal"
          data-bs-dismiss="modal"
          data-bs-target="#MBottomMainSlideModal"
        >
          <i class="mc-menu"></i>
          <span class="">{{
            $t('layout.Footer.mobile.bottomMenu.list.menu')
          }}</span>
        </button>
        <button
          data-bs-toggle="modal"
          data-bs-dismiss="modal"
          data-bs-target="#MBottomMenuGame"
          class="m-bottom-menu-list-item"
        >
          <i class="mc-game-menu"></i>
          <span>{{ $t('layout.Footer.mobile.bottomMenu.list.casino') }}</span>
        </button>
        <button
          v-if="!user"
          class="m-bottom-menu-list-item"
          @click.prevent="$router.push('/beginner/registration')"
        >
          <i class="mc-beginner"></i>
          <span>{{ $t('layout.Footer.mobile.bottomMenu.list.beginner') }}</span>
        </button>
        <button
          v-else
          data-bs-toggle="modal"
          data-bs-dismiss="modal"
          data-bs-target="#MBottomMenuWallet"
          class="m-bottom-menu-list-item"
        >
          <i class="mc-wallet"></i>
          <span>{{ $t('layout.Footer.mobile.bottomMenu.list.wallet') }}</span>
        </button>
        <!--        -->
        <button
          v-if="!user"
          class="m-bottom-menu-list-item m-bottom-menu-login-btn"
          @click.prevent="linkToOpenAuthModal('signUp')"
        >
          <i class="mc-sign-up"></i>
          <span class="">{{
            $t('layout.Footer.mobile.bottomMenu.list.signUp')
          }}</span>
        </button>
        <button
          v-else
          class="m-bottom-menu-list-item m-bottom-menu-login-btn"
          @click.prevent="$router.push('/user/financial-service/deposit')"
        >
          <i class="mc-deposit"></i>
          <span class="">{{
            $t('layout.Footer.mobile.bottomMenu.list.deposit')
          }}</span>
        </button>
      </nav>
    </section>
    <client-only>
      <SlideModal
        ref="MBottomMainSlideModal"
        name="MBottomMainSlideModal"
        slide-direction="left"
        custom-class="m-bottom-main-slide-modal"
        @closed="closed"
      >
        <template v-slot:header>
          <MainMenuHeader />
        </template>
        <MainMenuContent />
        <template v-slot:footer>
          <MainMenuFooter />
        </template>
      </SlideModal>
      <!--      -->
      <MBottomMenuGame />
      <MBottomMenuWallet />
    </client-only>
  </div>
</template>

<script>
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import useComp from '../../../composables/useComp'
import SlideModal from '../../components/SlideModal.vue'
import useTitle from '../../../composables/useTitle'
import MainMenuHeader from '../../components/layouts/MainMenuHeader.vue'
import MainMenuContent from '../../components/layouts/MainMenuContent.vue'
import useUser from '../../../composables/useUser'
import MainMenuFooter from '../../components/layouts/MainMenuFooter.vue'
import useLocale from '../../../composables/useLocale'
import useAuthModal from '../../../composables/useAuthModal'
import MBottomMenuGame from './MBottomMenuGame.vue'
import MBottomMenuWallet from './MBottomMenuWallet.vue'

export default defineComponent({
  name: 'MBottomMenu',
  components: {
    MainMenuFooter,
    MainMenuContent,
    MainMenuHeader,
    SlideModal,
    MBottomMenuGame,
    MBottomMenuWallet
  },
  props: {
    name: {
      type: String,
      default: 'MBottomMenu'
    },
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const store = useStore()
    const { title } = useTitle()
    const { user } = useUser(context)
    const { compCommon, comMainBottomMenuList, compId } = useComp()
    const { locale } = useLocale()
    const { linkToOpenAuthModal } = useAuthModal(context)

    const templateId = computed(() => process.env.TEMPLATE_ID)

    function closed() {
      store.commit('headerModule/SHOW_MENU_SWITCH_LOCALE_CONTENT', false)
    }

    return {
      compCommon,
      compId,
      templateId,
      comMainBottomMenuList,
      title,
      user,
      locale,
      closed,
      linkToOpenAuthModal
    }
  }
})
</script>
